<template>
    <div class="more-button" @click="handleClick">
        <span class="more-button__text">{{ text }}</span>
    </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  text: {
    type: String,
    default: 'More'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const handleClick = () => {
    emit('click');
  };
  return {
    handleClick
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.more-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.24rem 0;
    cursor: pointer;

    &__text {
        font-size: 0.28rem;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        text-decoration: underline;
    }
}
</style>

